import { mergeStyles } from "@fluentui/react";
import React from "react";
// Constants
import { UnoHeaderDimensions, UnoHeaderStyles } from "../../../constants/StyleConstants";
export const HeaderPlaceHolder = ()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: mergeStyles(UnoHeaderDimensions, UnoHeaderStyles)
    });
};
